<template>
  <div v-loading="isLoading">
    <el-table
      :data="items"
      stripe
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-row :gutter="10">
            <el-col :md="8">
              <p><strong>Name: </strong>{{ props.row.name || '-' }}</p>
              <p><strong>Code: </strong>{{ props.row.code || '-' }}</p>
              <p><strong>Default Quantity: </strong>{{ props.row.default_qty || '1' }}</p>
            </el-col>
            <el-col :md="8">
              <p><strong>Length: </strong>{{ props.row.length + 'cm' || '-' }}</p>
              <p><strong>Width: </strong>{{ props.row.width + 'cm' || '-' }}</p>
              <p><strong>Height: </strong>{{ props.row.height + 'cm' || '-' }}</p>
              <p><strong>Weight: </strong>{{ props.row.weight + 'kg' || '-' }}</p>
            </el-col>
            <el-col :md="8">
              <p><strong>Service: </strong>{{ props.row.service ? props.row.service.name : '-' || 'N/A' }}</p>
              <p><strong>DG: </strong>{{ props.row.dg ? props.row.dg.itemdg_propname : '-' || 'N/A' }}</p>
            </el-col>
          </el-row>
        </template>
      </el-table-column>

      <el-table-column
        label="Name"
        prop="name"
        min-width="320px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Code"
        prop="code"
        width="120px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Length"
        prop="length"
        width="80px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Width"
        prop="width"
        width="80px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Height"
        prop="height"
        width="120px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Weight"
        prop="weight"
        width="120px"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
        width="270px"
      >
        <template slot-scope="scope">
          <!-- <el-button
            v-if="canUpdate"
            size="mini"
            @click.native="editItem(scope.$index, scope.row)"
          >
            Edit
          </el-button> -->
          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deleteItem(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
  </div>
</template>

<script>
// import { CREATE, UPDATE, DELETE } from '@/plugins/user'

export default {
  props: {
    filters: {
      type: Array,
      required: true
    },
    accountId: {
      type: String,
      required: true
    },
    sort: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      item: null,
      items: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: true,
      isShowEditForm: false
    }
  },
  computed: {
    canUpdate () {
      return true
    },
    canDelete () {
      return true
    }
  },
  mounted () {
    this.actions = [
      [
        {
          name: 'Import',
          icon: ['fal', 'upload'],
          event: () => {
            this.$emit('update:isShowImport', true)
          }
        },
        {
          name: 'Export',
          icon: ['fal', 'sync'],
          event: () => {
            this.$emit('update:isShow', true)
          }
        }
      ],
      [
        {
          hidden: true,
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.item = new this.$sdk.account_item()
            this.isShowEditForm = true
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.loadTable()
        }
      ]
    ]
  },
  methods: {
    showPreview () {
      this.$emit('update:isShowPreview', true)
    },
    loadTable () {
      this.isLoading = true
      this.$sdk.account_item.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = `${this.sort.field}:${this.sort.direction}`
        builder.filters = this.filters
      })
        .then(res => {
          this.items = res
          this.total = res.total
        })
        .finally(() => { this.isLoading = false })
    },
    editItem (index, row) {
      this.item = row.clone()
      this.isShowEditForm = true
    },
    deleteItem (index, row) {
      this.$confirm('Are you sure to delete this item?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
